import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { PreferredSupplierDetailsComponent } from './preferred-supplier-details.component';
import { ToastModule } from 'primeng';

const routes: Routes = [
  {
    path: '',
    component: PreferredSupplierDetailsComponent,
    data: { title: 'VME Preferred Suppliers Details' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PreferredSupplierDetailsRoutingModule {}

@NgModule({
  imports: [
    PreferredSupplierDetailsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [PreferredSupplierDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PreferredSupplierDetailsModule {}
